












































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import HtmlEditor from "../controls/HtmlEditor.vue";
import Loading from "../general/Loading.vue";

import { WeekDay, WeekDayNames } from "../../shared/WeekDay";
import { Month, MonthNames } from "../../shared/Month";
import UserJson from "../../shared/UserJson";
import BirthdayBookingInfoJson from "../../shared/BirthdayBookingInfoJson";
import BirthdayProgramJson, {
  BirthdayProgramDescriptionAllowedTags,
  getDefaultBirthdayProgramData,
} from "../../shared/BirthdayProgramJson";

import Utils from "../../shared/Utils";
import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { validateBirthdayProgramJson, validateBirthdayProgramJsonAddNew } from "../../shared/BirthdayProgramJson";
import { ValidationResult, Validation } from "../../shared/Validation";

type keysForCachedPrices = {
  [key in keyof Pick<BirthdayProgramJson, "basePrice" | "extraParticipantPrice" | "cancellationFee">]: string;
};

export default Vue.extend({
  name: "BirthdaysPrgramDetails",
  components: {
    OverlayWindow,
    PointerMenu,
    HtmlEditor,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    programId: Number,
    mode: String,
    categories: Array,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      Utils: Utils,
      BirthdayProgramDescriptionAllowedTags: BirthdayProgramDescriptionAllowedTags,
      editable: false as boolean,
      detailsTitle: "",
      allUsers: null as UserJson[] | null,
      birthdayBookingInfo: null as BirthdayBookingInfoJson | null,
      UserPermissionRank: UserPermissionRank,
      detailsMode: "",
      WeekDayNames: WeekDayNames,
      MonthNames: MonthNames,
      selectedProgramId: null as number | null,
      programDetails: null as BirthdayProgramJson | null,
      useAlternateTimeSlots: false as boolean,
      cachedPrices: {
        basePrice: "0,00",
        extraParticipantPrice: "0,00",
        cancellationFee: "0,00",
      } as keysForCachedPrices,
      cachedRestrictStaffAssignmentIds: [] as number[],
      cachedRestrictWeekDays: [] as WeekDay[],
      cachedRestrictMonths: [] as Month[],
      hasChanges: false,
      validationAlternateTimeSlots: {} as any,
      toValidate: {} as any,
      validation: null as ValidationResult<BirthdayProgramJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initDetails();
  },
  mounted() {
    this.setCachedData();
  },
  methods: {
    initDetails() {
      this.selectedProgramId = this.programId;

      this.loadAllUsers();
      this.loadBirthdayBookingInfo();
      this.loadDetails();

      this.selectDetailsMode(this.mode);
    },

    setCachedData() {
      this.setCachedPrices();
      this.setCachedRestrictStaffAssignmentIds();
      this.setCachedRestrictWeekDays();
      this.setCachedRestrictMonths();
    },

    async loadDetails() {
      if (this.selectedProgramId != null) {
        if (this.restClient != null) {
          try {
            this.programDetails = await this.restClient.getBirthdayProgram(this.selectedProgramId);

            if (this.programDetails.alternateTimeSlots != null) {
              this.useAlternateTimeSlots = true;
            }
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.programDetails = { ...getDefaultBirthdayProgramData() };
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    async loadAllUsers() {
      this.allUsers = null;
      if (this.restClient != null) {
        try {
          this.allUsers = await this.restClient.getUsers();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadBirthdayBookingInfo() {
      this.birthdayBookingInfo = null;
      try {
        let rc = RestClient;
        this.birthdayBookingInfo = await rc.getBirthdayBookingInfo();
      } catch (e) {
        alert(e.message);
      }
    },

    toggleUseAlternateTimeSlots() {
      if (this.programDetails != null) {
        if (this.useAlternateTimeSlots) {
          this.programDetails.alternateTimeSlots = null;
          this.useAlternateTimeSlots = false;
        } else {
          if (this.birthdayBookingInfo != null) {
            this.programDetails.alternateTimeSlots = JSON.parse(
              JSON.stringify(this.birthdayBookingInfo.customTimeSlots)
            );
            this.useAlternateTimeSlots = true;
          }
        }
      }
    },

    resetAlternateTimeSlots() {
      if (this.programDetails != null && this.birthdayBookingInfo != null) {
        if (this.useAlternateTimeSlots) {
          this.programDetails.alternateTimeSlots = null;

          this.programDetails.alternateTimeSlots = JSON.parse(JSON.stringify(this.birthdayBookingInfo.customTimeSlots));
        }
      }
    },

    selectDetailsMode(mode: string) {
      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Programm hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Programm bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Programm";
          this.editable = false;
          break;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        //fliegt viell. komplett raus wegen reload
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.programDetails != null) {
        this.validation = validateBirthdayProgramJson(this.programDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    timeSlotValidation(index: number) {
      if (this.programDetails != null && this.programDetails.alternateTimeSlots != null) {
        const alternateBegin = this.programDetails.alternateTimeSlots[index].beginTime;
        const alternateEnd = this.programDetails.alternateTimeSlots[index].endTime;

        if (alternateBegin != "" && alternateEnd != "") {
          if (this.birthdayBookingInfo != null) {
            var check = false;

            for (let i = 0; i < this.birthdayBookingInfo.customTimeSlots.length; i++) {
              let slotBegin = DateFormatter.parseTime(this.birthdayBookingInfo.customTimeSlots[i].beginTime);
              let slotEnd = DateFormatter.parseTime(this.birthdayBookingInfo.customTimeSlots[i].endTime);

              let begin = DateFormatter.parseTime(alternateBegin);
              let end = DateFormatter.parseTime(alternateEnd);

              if (slotBegin != null && slotEnd != null && begin != null && end != null) {
                if (this.checkTimeInTimeSlot(slotBegin, slotEnd, begin)) {
                  if (this.checkTimeInTimeSlot(slotBegin, slotEnd, end)) {
                    check = true;
                    break;
                  }
                }
              }
            }

            if (check) {
              delete this.validationAlternateTimeSlots[index];
            } else {
              this.validationAlternateTimeSlots[index] = true;
            }
          }
        }
      }
    },

    removeTimeSlotValidationHint(index: number) {
      delete this.validationAlternateTimeSlots[index];

      this.$forceUpdate();
    },

    checkTimeInTimeSlot(begin: Date, end: Date, time: Date) {
      if (time >= begin && time <= end) {
        return true;
      } else {
        return false;
      }
    },

    checkAlternateTimeSlotValidation() {
      let check = true;

      let k = this.validationAlternateTimeSlots;
      let i: keyof typeof k;
      for (i in this.validationAlternateTimeSlots) {
        if (this.validationAlternateTimeSlots[i] == true) {
          check = false;
        }
      }

      return check;
    },

    async addNewProgram() {
      if (this.programDetails != null) {
        this.loadingGeneral = true;
        this.submitValidation = true;

        this.validation = validateBirthdayProgramJsonAddNew(this.programDetails);

        if (this.checkAlternateTimeSlotValidation() && this.validation != null && this.validation.isValid == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.addBirthdayProgram(this.programDetails);
              alert("Das Program wurde erfolgreich hinzugefügt.");

              this.hasChanges = false;
              this.loadingGeneral = false;
              this.submitValidation = false;
              //this.stopEditMode();
              this.closeDetails();
            } catch (e) {
              this.loadingGeneral = false;
              alert(e.message);
            }
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Das Program konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveProgramDetails() {
      if (this.programDetails != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;
          this.submitValidation = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateBirthdayProgramJson(this.programDetails);
          //todo ###END
          if (this.checkAlternateTimeSlotValidation() && this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                await this.restClient.updateBirthdayProgram(this.programDetails);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.submitValidation = false;
                this.stopEditMode();

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteProgram() {
      if (this.programDetails != null) {
        let c = confirm("Wollen Sie dieses Program wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteBirthdayProgram(this.programDetails);
              this.closeDetails();
              alert("Das Programm wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    /* getUpdatedBirthdayPrograms(): { [index: string]: BirthdayProgramJson[] } | undefined {
      if (this.allPrograms != null && this.programDetails != null) {
        let updatedBirthdayPrograms: { [index: string]: BirthdayProgramJson[] } = this.allPrograms;

        const category = this.programDetails?.category;

        if (category !== undefined) {
          const index = updatedBirthdayPrograms[category].findIndex((i: any) => i.ID == this.programId);

          if (index !== undefined) {
            updatedBirthdayPrograms[category][index] = this.programDetails;

            return updatedBirthdayPrograms;
          }
        }
      }

      return undefined;
    }, */

    /*** START control cached data ***/

    /* set cached data */

    setCachedPrices() {
      if (this.programDetails != null) {
        let k = this.cachedPrices;
        let i: keyof typeof k;

        for (i in this.cachedPrices) {
          let price = this.programDetails[i]
            .toString()
            .padStart(3, "0")
            .replace(/(\d{2,2})$/g, ",$1")
            .replace("NaN", "");

          this.cachedPrices[i] = price;
        }
      }
    },

    setCachedRestrictStaffAssignmentIds() {
      if (this.programDetails != null) {
        if (this.programDetails.restrictStaffAssignmentIds == null) {
          this.cachedRestrictStaffAssignmentIds = [];
        } else {
          this.cachedRestrictStaffAssignmentIds = this.programDetails.restrictStaffAssignmentIds;
        }
      }
    },

    setCachedRestrictWeekDays() {
      if (this.programDetails != null) {
        if (this.programDetails.restrictWeekDays == null) {
          this.cachedRestrictWeekDays = [];
        } else {
          this.cachedRestrictWeekDays = this.programDetails.restrictWeekDays;
        }
      }
    },

    setCachedRestrictMonths() {
      if (this.programDetails != null) {
        if (this.programDetails.restrictMonths == null) {
          this.cachedRestrictMonths = [];
        } else {
          this.cachedRestrictMonths = this.programDetails.restrictMonths;
        }
      }
    },

    /* format and set data where be cached */

    formatAndSetPrices(key: keyof keysForCachedPrices) {
      if (this.programDetails != null) {
        let price = this.cachedPrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[key] = price;
        this.programDetails[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    formatAndSetRestrictStaffAssignmentIds() {
      if (this.programDetails != null) {
        if (this.cachedRestrictStaffAssignmentIds.length > 0) {
          this.programDetails.restrictStaffAssignmentIds = this.cachedRestrictStaffAssignmentIds;
        } else {
          this.programDetails.restrictStaffAssignmentIds = null;
        }
      }
    },

    formatAndSetRestrictWeekDays() {
      if (this.programDetails != null) {
        if (this.cachedRestrictWeekDays.length > 0) {
          this.programDetails.restrictWeekDays = this.cachedRestrictWeekDays;
        } else {
          this.programDetails.restrictWeekDays = null;
        }
      }
    },

    formatAndSetRestrictMonths() {
      if (this.programDetails != null) {
        if (this.cachedRestrictMonths.length > 0) {
          this.programDetails.restrictMonths = this.cachedRestrictMonths;
        } else {
          this.programDetails.restrictMonths = null;
        }
      }
    },

    /*** END control cached data ***/

    getUserFullNameById(userId: number) {
      if (this.allUsers != null) {
        let user = this.allUsers.find((user) => user.ID == userId);

        return user?.firstName + " " + user?.lastName;
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    programDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    getRestrictStaffAssignmentNames(): string | undefined {
      if (this.programDetails != null) {
        if (this.programDetails.restrictStaffAssignmentIds != null) {
          let restrictStaff = [];

          for (let i = 0; i < this.programDetails.restrictStaffAssignmentIds.length; i++) {
            restrictStaff.push(this.getUserFullNameById(this.programDetails.restrictStaffAssignmentIds[i]));
          }

          return restrictStaff.join(", ");
        } else {
          return "Alle";
        }
      }
    },

    getRestrictWeekDayNames(): string | undefined {
      if (this.programDetails != null) {
        if (this.programDetails.restrictWeekDays != null) {
          let restrictWeekDays = [];

          for (let i = 0; i < this.programDetails.restrictWeekDays.length; i++) {
            restrictWeekDays.push(this.WeekDayNames[this.programDetails.restrictWeekDays[i]]);
          }

          return restrictWeekDays.join(", ");
        } else {
          return "Alle";
        }
      }
    },

    getRestrictMonthNames(): string | undefined {
      if (this.programDetails != null) {
        if (this.programDetails.restrictMonths != null) {
          let restrictMonths = [];

          for (let i = 0; i < this.programDetails.restrictMonths.length; i++) {
            restrictMonths.push(this.MonthNames[this.programDetails.restrictMonths[i]]);
          }

          return restrictMonths.join(", ");
        } else {
          return "Alle";
        }
      }
    },

    parseBasePriceParticipantCount: {
      get(): number | undefined {
        if (this.programDetails != null) {
          return this.programDetails.basePriceParticipantCount;
        }
      },
      set(value: string) {
        if (this.programDetails != null) {
          this.programDetails.basePriceParticipantCount = parseInt(value);
        }
      },
    },

    parseRestrictMaximumParticipants: {
      get(): number | null | undefined {
        if (this.programDetails != null) {
          return this.programDetails.restrictMaximumParticipants;
        }
      },
      set(value: string) {
        if (this.programDetails != null) {
          if (value == "") {
            this.programDetails.restrictMaximumParticipants = null;
          } else {
            this.programDetails.restrictMaximumParticipants = parseInt(value);
          }
        }
      },
    },

    parseRestrictMinimumAge: {
      get(): number | null | undefined {
        if (this.programDetails != null) {
          return this.programDetails.restrictMinimumAge;
        }
      },
      set(value: string) {
        if (this.programDetails != null) {
          if (value == "") {
            this.programDetails.restrictMinimumAge = null;
          } else {
            this.programDetails.restrictMinimumAge = parseInt(value);
          }
        }
      },
    },

    parseRestrictMaximumAge: {
      get(): number | null | undefined {
        if (this.programDetails != null) {
          return this.programDetails.restrictMaximumAge;
        }
      },
      set(value: string) {
        if (this.programDetails != null) {
          if (value == "") {
            this.programDetails.restrictMaximumAge = null;
          } else {
            this.programDetails.restrictMaximumAge = parseInt(value);
          }
        }
      },
    },

    parseRestrictMaximumSimultaneous: {
      get(): number | null | undefined {
        if (this.programDetails != null) {
          return this.programDetails.restrictMaximumSimultaneous;
        }
      },
      set(value: string) {
        if (this.programDetails != null) {
          if (value == "") {
            this.programDetails.restrictMaximumSimultaneous = null;
          } else {
            this.programDetails.restrictMaximumSimultaneous = parseInt(value);
          }
        }
      },
    },
  },
});
